export const PaymentStepsGravy = {
  SelectPriceSettings: 'SelectPriceSettings',
  GravyForm: 'GravyForm',
  SuccessPurchaseConfirmation: 'SuccessPurchaseConfirmation',
}
